import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade } from '@ridango/components';
import { FavoriteSchedule } from '@ridango/components/lib/favorites/favorites.model';

@Component({
    selector: 'rwidget-explore-favorite-schedule-item',
    templateUrl: './explore-favorite-schedule-item.component.html',
    styleUrls: ['./explore-favorite-schedule-item.component.scss']
})
export class ExploreFavoriteScheduleItemComponent {
    @Input() favoriteSchedule: FavoriteSchedule;

    public readonly assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private applicationFacade: ApplicationFacade,
        private router: Router,
        private translate: TranslateService
    ) {}

    public async redirectToSchedule(): Promise<boolean> {
        const { patternId, stop } = this.favoriteSchedule;

        return await this.router.navigate(
            [this.translate.currentLang, 'explore', 'pattern', patternId, 'schedule', 'stop', stop.id],
            { queryParams: { scheduleId: this.favoriteSchedule.id } }
        );
    }
}
